import {CategoryTypeVo} from '../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import {MainTabItemType} from '../../design-system/organisms/MainTab/MainTabItemType.interface';

export const STATIC_LANDING_ORIGINAL_CATEGORY_LIST: MainTabItemType[] = [
  {
    id: CategoryTypeVo.Cartoon,
    text: '웹툰',
    textTKey: 'common_category_webcomic',
    href: `/landing/original/${CategoryTypeVo.Cartoon}`,
  },
  {
    id: CategoryTypeVo.Novel,
    text: '웹소설',
    textTKey: 'common_category_webnovels',
    href: `/landing/original/${CategoryTypeVo.Novel}`,
  },
];
